$(document).ready(function(){

    $('.burger').on('click', function(){
        const menu = $('.menu')

        $(this).toggleClass('burger--active')
        $('body').toggleClass('hidden')
        menu.slideToggle();
    });
});
